import { Component, OnInit, inject } from '@angular/core'
import { OidcSecurityService } from 'angular-auth-oidc-client'

@Component({
    template: `<div></div>`,
    standalone: false
})
export class PostLogoutComponent implements OnInit {
    private oidcSecurityService = inject(OidcSecurityService);

    publicWebsiteUrl: string

    ngOnInit() {
        this.oidcSecurityService.authorize()
    }
}
